<template>
  <div class="referral-item">
    <v-btn icon
           v-if="itemId !== 0"
           class="delete-icon"
           @click="deleteReferral">
      <v-icon>close</v-icon>
    </v-btn>

    <v-flex xs12>
      <v-select attach
                hide-details
                :label="$t('email_referral_title')"
                :items="referralFields"
                v-model="referralValue"
                item-disabled="disabled"
                max-height="240" />
    </v-flex>

    <v-flex xs12 v-if="selectedItem && selectedItem.value && !selectedItem.url">
      <v-text-field :label="$t('referral_summary_label')"
                    v-model="referralText"
                    multi-line
                    hide-details />
    </v-flex>

    <v-flex xs12 mt-3 v-if="selectedItem && selectedItem.value && !selectedItem.url"
            :class="{'mb-3': itemId === 0}">
      <span class="subheading">{{$t('intervention_recipients.sub_header')}}</span>
      <v-select attach
                v-model="referralRecipients"
                class="mb-2"
                :items="translatedRecipientsTypes"
                hide-selected
                :label="$t('intervention_recipients.recipients_label')"
                multiple chips
                deletable-chips
                autocomplete
                hide-details />
      <span v-if="invalidFreestyleEmail" class="caption error--text">{{$t('intervention_recipients.invalid_email')}}</span>
      <v-checkbox v-model="freestyle"
                  :label="$t('intervention_recipients.freestyle_checkbox_label')"
                  hide-details
                  color="primary" />
      <v-text-field v-if="freestyle"
                    v-model="freeTextSelection"
                    clearable
                    :hint="$t('intervention_recipients.freestyle_hint')"
                    :placeholder="$t('intervention_recipients.freestyle_placeholder')"
                    @keyup.enter="updateFreeText" />
    </v-flex>
  </div>
</template>

<script>
  import { mapMutations, mapState } from 'vuex'
  import Helpers from '../../mixins/Helpers'
  import { CONCAT_INTERVENTION_RECIPIENT_TYPES, REMOVE_INTERVENTION_REFERRAL } from '../../store/mutation-types'

  export default {
    name: 'InteractionReferral',
    mixins: [Helpers],
    props: {
      item: {
        type: Object
      },
      itemId: {
        type: Number
      }
    },
    data () {
      return {
        referralValue: this.item.refereeId ? this.item.refereeId : null,
        referralText: this.item.referralSummary ? this.item.referralSummary : '',
        referralRecipients: this.item.recipients.map((re) => re.type === 'FREESTYLE' ? re.email : re.type),
        freeTextSelection: '',
        freestyle: false
      }
    },
    computed: {
      ...mapState({
        referrals: state => state.intervention.referrals,
        referralList: state => state.intervention.referralList,
        recipientTypes: state => state.intervention.recipientTypes,
        originalRecipientTypes: state => state.intervention.originalRecipientTypes,
        invalidFreestyleEmail: state => state.intervention.invalidFreestyleEmail,
        emailReg: state => state.intervention.emailReg
      }),
      referralFields () {
        const referrals = this.translateFields(this.referrals.filter(r => !r.url))
        const selectedValue = this.referralList.map(referral => referral.refereeId)
        referrals.forEach((input) => {
          input.disabled = (input.value !== this.referralValue && selectedValue.indexOf(input.value) > -1)
        })
        return referrals
      },
      selectedItem () {
        return this.referrals.find(referral => referral.value === this.referralValue)
      },
      translatedRecipientsTypes () {
        return this.translateFields(this.recipientTypes)
      },
      originalValues () {
        return this.originalRecipientTypes.map(el => el.value)
      },
      buildRecipients () {
        return this.referralRecipients.map(el => {
          if (this.originalValues.includes(el)) {
            return {
              type: el,
              email: null
            }
          } else {
            return {
              type: 'FREESTYLE',
              email: el
            }
          }
        })
      }
    },
    methods: {
      ...mapMutations({
        concatInterventionRecipientType: CONCAT_INTERVENTION_RECIPIENT_TYPES,
        removeInterventionReferral: REMOVE_INTERVENTION_REFERRAL
      }),
      updateFreeText () {
        if (this.emailReg.test(this.freeTextSelection)) {
          let obj = {
            text: this.freeTextSelection,
            value: this.freeTextSelection
          }
          if (this.referralRecipients.indexOf(this.freeTextSelection) === -1) {
            this.concatInterventionRecipientType(obj)
            this.referralRecipients = this.referralRecipients.concat(this.freeTextSelection)
          }
        }
        this.freeTextSelection = ''
      },
      deleteReferral () {
        this.removeInterventionReferral(this.item.refereeId)
      }
    },
    watch: {
      referralValue (value) {
        this.$emit('getReferralValue', {
          id: this.itemId,
          value: value
        })
      },
      referralText (value) {
        this.$emit('getReferralSummary', {
          id: this.itemId,
          text: value
        })
      },
      referralRecipients (value) {
        this.$emit('getRecipients', {
          id: this.itemId,
          recipients: this.buildRecipients
        })
      },
      item (value) {
        if (value) {
          this.referralValue = value.refereeId
          this.referralText = value.referralSummary
          this.referralRecipients = value.recipients.map((re) => re.type === 'FREESTYLE' ? re.email : re.type)
        }
      }
    }
  }
</script>

<style scoped>
  .subheading {
    font-size: 14px !important;
  }

  .referral-item.bordered {
    position: relative;
    border: 1px dashed transparent;
    padding: 20px 10px;
  }

  .delete-icon {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 1;
  }
</style>



// WEBPACK FOOTER //
// src/components/intervention/InteractionReferral.vue